import React, {Component} from 'react';
import FilterInput from './molecules/filter-input';
import FilterSlider from './molecules/filter-slider';

class ProjectedOwnershipCap extends Component {
    render() {
        const {step = 5, roundValue = 5, useDragging} = this.props;

        return (
            <div className="filters-cell lineups-cell">
                <div className="filter-group">
                    <strong className="filter-title">Projected Ownership Cap</strong>
                    <div className="range-holder">
                        <div className="slider-wrap">
                            <FilterSlider step={step} useDragging={useDragging} />
                        </div>
                        <div className="range-wrap">
                            <FilterInput fieldName="min" roundValue={roundValue} testId="min-proj-own-cap-input" />
                            <FilterInput fieldName="max" roundValue={roundValue} testId="max-proj-own-cap-input" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProjectedOwnershipCap;
